import{t as N,B as D,T as b,R as E,a6 as U,a7 as v,a8 as w,x as u,a9 as _,aa as O,ab as y,ac as $,ad as S,ae as q,af as z}from"./chunk-core-C-8Qoxie.js";var A=Object.defineProperty,I=Object.getOwnPropertyDescriptor,j=(e,t,a,r)=>{for(var s=r>1?void 0:r?I(t,a):t,n=e.length-1,i;n>=0;n--)(i=e[n])&&(s=(r?i(t,a,s):i(s))||s);return r&&s&&A(t,a,s),s};let k=class extends D{constructor(){super(...arguments),this.facets=[],this.rangeDrafts=new Map,this.openFields=new Set,this.activeFields=new Set,this.facetLabels=null,this.facetCache=new Map,this.userFilterPending=!1,this.panelScrollRestore=null,this._onResults=e=>{const t=e.detail;this.facets=(t==null?void 0:t.facets)??[];for(const a of this.facets){if(a.type!=="terms")continue;const r=a,s=this.facetCache.get(r.field)??{name:r.name||r.field,terms:new Map};r.name&&(s.name=r.name);for(const n of r.data)s.terms.set(n.value,n);this.facetCache.set(r.field,s)}if(this.userFilterPending){this.userFilterPending=!1,(t==null?void 0:t.total)===1&&window.matchMedia("(min-width: 1024px)").matches&&document.dispatchEvent(new CustomEvent("filters-panel:close"));const a=this.panelScrollRestore;a&&(this.panelScrollRestore=null,this.updateComplete.then(()=>{a.el.scrollTop=a.top}))}this.requestUpdate()},this._onPopState=()=>{this.requestUpdate()},this._onGroupToggle=(e,t)=>{const a=t.currentTarget;a&&(a.open?this.openFields.add(e):this.openFields.delete(e))}}_facetLabel(e,t){if(this.facetLabels===null)try{this.facetLabels=JSON.parse(this.getAttribute("facet-labels")??"{}")}catch{this.facetLabels={}}return this.facetLabels[e]||t||e}_scrollContainer(){let e=this.parentElement;for(;e&&e!==document.body;){const t=getComputedStyle(e).overflowY;if(t==="auto"||t==="scroll")return e;e=e.parentElement}return null}connectedCallback(){super.connectedCallback(),this._onResults=this._onResults.bind(this),this._onPopState=this._onPopState.bind(this),document.addEventListener(b,this._onResults),window.addEventListener("popstate",this._onPopState)}disconnectedCallback(){super.disconnectedCallback(),document.removeEventListener(b,this._onResults),window.removeEventListener("popstate",this._onPopState)}_applyQuery(e){this.userFilterPending=!0;const t=this._scrollContainer();t&&(this.panelScrollRestore={el:t,top:t.scrollTop});const a=new URL(location.href);a.search=e?`?${e}`:"",history.pushState(history.state,"",`${a.pathname}${a.search}${a.hash}`),document.dispatchEvent(new CustomEvent(E,{bubbles:!0,composed:!0})),this.requestUpdate()}_toggleTerm(e,t){const a=new URLSearchParams(location.search);this._applyQuery(U(a,e,t))}_getRangeDraft(e){const t=new URLSearchParams(location.search),a={gte:t.get(v(e,"gte"))??"",lte:t.get(v(e,"lte"))??""};return this.rangeDrafts.get(e)??a}_setRangeDraft(e,t,a){const r=this._getRangeDraft(e.field),s=Number(e.min),n=Number(e.max),i=Math.min(Math.max(Number(a),s),n),o={gte:r.gte||String(s),lte:r.lte||String(n)};if(t==="gte"){const l=Math.max(s,Number(o.lte||n)-1);o.gte=String(Math.min(i,l))}else{const l=Math.min(n,Number(o.gte||s)+1);o.lte=String(Math.max(i,l))}this.rangeDrafts.set(e.field,o),this.requestUpdate()}_commitRangeDraft(e){const t=e.field,a=this._getRangeDraft(t),r=Number(e.min),s=Number(e.max),n=Number(a.gte||r),i=Number(a.lte||s),o=new URLSearchParams(location.search),c=n<=r&&i>=s?w(o,t,null,null):w(o,t,a.gte||null,a.lte||null);this.rangeDrafts.delete(t),this._applyQuery(c)}_formatPrice(e){const t=Number(e);return Number.isFinite(t)?t.toLocaleString():String(e)}_renderTermSwatch(e,t){const a=e.visual;if(!(a!=null&&a.value))return null;const r=a.type==="thumbnail"?`background-image: url(${a.value});`:`background-color: ${a.value};`;return u`
      <span
        aria-hidden="true"
        class=${`box-border block aspect-square w-[15px] shrink-0 rounded-full border-[0.5px] border-solid border-[#CECDC8] bg-cover bg-center bg-no-repeat transition-[box-shadow] ease-out motion-reduce:transition-none ${t?"ring-[1px] ring-[color:var(--color-foreground,#000)] ring-offset-2 ring-offset-[color:var(--color-background,#fff)]":""}`}
        style=${r}
      ></span>
    `}_resolveOpen(e,t){const a=this.activeFields.has(e);return t?(this.activeFields.add(e),a||this.openFields.add(e)):this.activeFields.delete(e),this.openFields.has(e)}_renderTermFacet(e,t){const a=new URLSearchParams(location.search),r=e.data,s=r.filter(n=>_(e,n,a)).length;return u`
      <details
        class=${`js-filter group/details pt-5 lg:pt-2.5 ${t?"pt-0 lg:pt-0":""}`}
        data-facet-accordion
        ?data-facet-active=${s>0}
        ?open=${this._resolveOpen(e.field,s>0)}
        @toggle=${n=>this._onGroupToggle(e.field,n)}
      >
        <summary
          class="collection-facet-header focus-inset mb-1 block flex w-full cursor-pointer list-none items-center gap-x-xs pt-xs [&::-webkit-details-marker]:hidden"
        >
          <span
            class="text-utility-2 text-[13px] leading-none text-t-foreground"
            style="font-weight: 300;"
            >${this._facetLabel(e.field,e.name)}${s>0?` (${s})`:""}</span
          >
          <span class="ml-auto flex shrink-0 items-center justify-center">
            <span
              class="mr-[10px] inline-flex h-[1em] w-[1em] rotate-90 transition-transform duration-300 group-open/details:-rotate-90"
              style="font-size: 12px;"
            >
              <svg class="block h-full w-full" aria-hidden="true">
                <use xlink:href="#icon-chevron"></use>
              </svg>
            </span>
          </span>
        </summary>
        <div class="pb-sm pt-2xs lg:pb-1">
          <ul class="list-unstyled" role="list">
            ${r.map(n=>{const i=_(e,n,a);return u`
                <li class="py-2 pl-[11px]">
                  <label
                    class="group/checkbox relative flex cursor-pointer items-center justify-start gap-2"
                  >
                    <span class="flex flex-1 items-center gap-[12px]">
                      ${this._renderTermSwatch(n,i)}
                      <span
                        class=${`text-utility text-[13px] select-none leading-none text-t-foreground group-has-[:disabled]/checkbox:text-t-border ${i?"font-medium":""}`}
                        >${n.value}</span
                      >
                    </span>
                    <!-- Checkbox hidden (sr-only), placed last so the global
                         input:checked + span rule can't recolor the label -->
                    <input
                      type="checkbox"
                      class="sr-only"
                      .checked=${i}
                      @change=${()=>this._toggleTerm(e.field,n.value)}
                    />
                  </label>
                </li>
              `})}
          </ul>
        </div>
      </details>
    `}_renderStatsFacet(e,t){const a=this._getRangeDraft(e.field),r=Number(e.min),s=Number(e.max),n=p=>Math.min(Math.max(p,r),s),i=n(Number(a.gte||r)),o=n(Number(a.lte||s)),l=Math.min(i,o),c=Math.max(i,o),h=s>r?(l-r)/(s-r)*100:0,R=s>r?(c-l)/(s-r)*100:0,F=`${Math.max(0,h)}%`,T=`${Math.max(0,Math.min(100,R))}%`,P=this._formatPrice(l),M=this._formatPrice(c),C=new URLSearchParams(location.search),g=O(C,e.field);return u`
      <details
        class=${`js-filter group/details pt-5 lg:pt-2.5 ${t?"pt-0 lg:pt-0":""}`}
        data-facet-accordion
        ?data-facet-active=${g}
        ?open=${this._resolveOpen(e.field,g)}
        @toggle=${p=>this._onGroupToggle(e.field,p)}
      >
        <summary
          class="collection-facet-header focus-inset mb-5 block flex w-full cursor-pointer list-none items-center gap-x-xs pt-xs [&::-webkit-details-marker]:hidden"
        >
          <span
            class="text-utility-2 text-[13px] leading-none text-t-foreground"
            style="font-weight: 300;"
            >${this._facetLabel(e.field,e.name)}${g?" (1)":""}</span
          >
          <span class="ml-auto flex shrink-0 items-center justify-center">
            <span
              class="mr-[10px] inline-flex h-[1em] w-[1em] rotate-90 transition-transform duration-300 group-open/details:-rotate-90"
              style="font-size: 12px;"
            >
              <svg class="block h-full w-full" aria-hidden="true">
                <use xlink:href="#icon-chevron"></use>
              </svg>
            </span>
          </span>
        </summary>
        <div class="pb-sm pt-2xs lg:pb-1">
          <div
            class="price-range-facet flex flex-col gap-2xs pl-[11px]"
            data-price-range
            data-range-max="${s}"
            data-step="1"
          >
            <span
              class="price-range-min-display caption !text-[13px] text-t-foreground-secondary"
              data-price-min-display
            >
              ${P}
            </span>
            <div
              class="price-range-track relative flex h-6 w-full items-center"
              data-price-track
              @pointerdown=${p=>{const d=p.currentTarget,x=d.getBoundingClientRect(),L=x.left+x.width/2,m=d.querySelector("[data-price-min]"),f=d.querySelector("[data-price-max]");!m||!f||(p.clientX<L?(m.style.zIndex="2",f.style.zIndex="1"):(m.style.zIndex="1",f.style.zIndex="2"))}}
            >
              <div
                class="price-range-fill pointer-events-none absolute top-1/2 -translate-y-1/2 rounded-full bg-t-foreground"
                data-price-fill
                style="height: 2px; left: ${F}; width: ${T};"
              ></div>
              <input
                type="range"
                class="price-range-input price-range-input-min"
                data-price-min
                min=${r}
                max=${s}
                step="1"
                .value=${y(String(l))}
                @input=${p=>{const d=p.currentTarget;this._setRangeDraft(e,"gte",d.value)}}
                @change=${()=>this._commitRangeDraft(e)}
              />
              <input
                type="range"
                class="price-range-input price-range-input-max"
                data-price-max
                min=${r}
                max=${s}
                step="1"
                .value=${y(String(c))}
                @input=${p=>{const d=p.currentTarget;this._setRangeDraft(e,"lte",d.value)}}
                @change=${()=>this._commitRangeDraft(e)}
              />
            </div>
            <span
              class="price-range-max-display caption text-right !text-[13px] text-t-foreground-secondary"
              data-price-max-display
            >
              ${M}
            </span>
          </div>
        </div>
        <style>
          .price-range-track {
            -webkit-tap-highlight-color: transparent;
          }
          .price-range-track::before {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 2px;
            background: rgb(217 217 217);
            border-radius: 2px;
            pointer-events: none;
          }
          .price-range-input {
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            height: 24px;
            margin: 0;
            padding: 0;
            -webkit-appearance: none;
            appearance: none;
            background: transparent;
            pointer-events: none;
          }
          .price-range-input::-webkit-slider-runnable-track {
            -webkit-appearance: none;
            height: 2px;
            background: transparent;
          }
          .price-range-input::-webkit-slider-thumb {
            -webkit-appearance: none;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            border: 2px solid var(--color-foreground, #000);
            background: var(--color-background, #fff);
            cursor: pointer;
            pointer-events: auto;
            margin-top: -7px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }
          .price-range-input::-moz-range-track {
            height: 2px;
            background: transparent;
          }
          .price-range-input::-moz-range-thumb {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            border: 2px solid var(--color-foreground, #000);
            background: var(--color-background, #fff);
            cursor: pointer;
            pointer-events: auto;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }
          .price-range-input-min {
            z-index: 2;
          }
          .price-range-input-max {
            z-index: 1;
          }
        </style>
      </details>
    `}_augmentedTermsFacets(e){const t=[],a=new Set;for(const s of this.facets){if(s.type!=="terms")continue;const n=s;a.add(n.field);const o=e.getAll($(n.field)).filter(c=>!n.data.some(h=>h.value===c));if(!o.length){t.push(n);continue}const l=this.facetCache.get(n.field);t.push({...n,data:[...n.data,...o.map(c=>(l==null?void 0:l.terms.get(c))??{value:c})]})}const r=new Set;e.forEach((s,n)=>{n.startsWith(S)&&r.add(n.slice(S.length))});for(const s of r){if(a.has(s))continue;const n=this.facetCache.get(s),i=e.getAll($(s));i.length&&t.push({type:"terms",field:s,name:(n==null?void 0:n.name)??s,data:i.map(o=>(n==null?void 0:n.terms.get(o))??{value:o})})}return t}render(){const e=new URLSearchParams(location.search),t=this._augmentedTermsFacets(e).filter(s=>q(s,e)),a=this.facets.filter(s=>s.type==="stats"&&z(s,e)),r=t.length>0;return u`
      <div
        class="collection-facets-form flex flex-col overflow-x-hidden [&[loading]]:pointer-events-none [&[loading]]:opacity-50"
      >
        ${t.map((s,n)=>this._renderTermFacet(s,n===0))}
        ${a.map((s,n)=>this._renderStatsFacet(s,n===0&&!r))}
      </div>
    `}};k=j([N("nosto-facets")],k);
